// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___cc6cac16ff793981b70","cls2":"SimplePaperPodcast-cls2__a7329ab1a3ce957c8e8c SimplePaperPodcast-cls1___cc6cac16ff793981b70"};